import React, { Component } from 'react';
import toPairs from 'lodash/toPairs';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cls from 'classnames';
import { any, arrayOf } from 'prop-types';
import Select from 'routes/preScore/components/Select';
import { PMT } from 'utils/helpers';
import { LIST_AMOUNT, formatMoney } from './constant';
import s from './SearchDeals.css';

class ZaloSearchDeals extends Component {
  state = {
    amount: 40,
    tenor: 27,
    interestRate: 0.32,
  };

  handleSeletecChange = e => {
    const { listAmount } = this.props;
    const { name, value } = e.target;

    if (name === 'amount') {
      const defaultTenor = listAmount[+value][0].tenor;

      this.setState(() => ({
        [name]: +value,
        tenor: defaultTenor,
      }));
    }
    this.setState(() => ({
      [name]: +value,
    }));
  };

  render() {
    const { amount, tenor, interestRate } = this.state;
    const { listAmount } = this.props;
    const amounts = toPairs(listAmount);
    const tenors = listAmount[amount];
    const monthlyPayment = -PMT(
      interestRate / 12,
      tenor,
      amount * 1000000,
    ).toFixed(0);

    return (
      <>
        <div>
          <div className={cls('row', s.row)}>
            <div className="col-md-3 col-4">
              <div className={s.label}>Số tiền</div>
            </div>
            <div className="col-md-9 col-8">
              <Select
                value={amount}
                name="amount"
                onChange={this.handleSeletecChange}
              >
                {amounts.map(([amountValue]) => (
                  <option value={amountValue} key={amountValue}>
                    {amountValue},000,000 VNĐ
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className={cls('row', s.row)}>
            <div className="col-md-3 col-4">
              <div className={s.label}>Kỳ hạn</div>
            </div>
            <div className="col-md-9 col-8">
              <Select
                value={tenor}
                name="tenor"
                onChange={this.handleSeletecChange}
              >
                {tenors.map(({ tenor: tenorValue }) => (
                  <option value={tenorValue} key={tenorValue}>
                    {tenorValue} tháng
                  </option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <p className={s.result}>
          Số tiền trả hàng tháng tạm tính:{' '}
          <span className={s.resultNumber}>
            {formatMoney(monthlyPayment)} đ
          </span>{' '}
          *
        </p>
      </>
    );
  }
}

ZaloSearchDeals.propTypes = {
  listAmount: arrayOf(any),
};

ZaloSearchDeals.defaultProps = {
  listAmount: LIST_AMOUNT,
};

export default withStyles(s)(ZaloSearchDeals);
